<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.ambassador.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAmbassadorForm :APIbaseURL="APIbaseURL" :ambassador="ambassador" :toSave="true" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAmbassadorForm } from 'aveine-ambassador'
import { Ambassador } from 'aveine-toolbox'

export default {
  data () {
    return {
      ambassador: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAmbassadorForm
  },
  async created() {
    this.ambassador = await Ambassador.new();

    this.ambassador.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
